import { InjectionToken } from '@angular/core';

export const COUNTRY_NAMES_DEFAULT = [
  $localize`Afghanistan`,
  $localize`Åland Islands`,
  $localize`Albania`,
  $localize`Algeria`,
  $localize`American Samoa`,
  $localize`Andorra`,
  $localize`Angola`,
  $localize`Anguilla`,
  $localize`Antarctica`,
  $localize`Antigua and Barbuda`,
  $localize`Argentina`,
  $localize`Armenia`,
  $localize`Aruba`,
  $localize`Australia`,
  $localize`Austria`,
  $localize`Azerbaijan`,
  $localize`Bahamas`,
  $localize`Bahrain`,
  $localize`Bangladesh`,
  $localize`Barbados`,
  $localize`Belarus`,
  $localize`Belgium`,
  $localize`Belize`,
  $localize`Benin`,
  $localize`Bermuda`,
  $localize`Bhutan`,
  $localize`Bolivia`,
  $localize`Bosnia and Herzegovina`,
  $localize`Botswana`,
  $localize`Bouvet Island`,
  $localize`Brazil`,
  $localize`British Indian Ocean Territory`,
  $localize`Brunei Darussalam`,
  $localize`Bulgaria`,
  $localize`Burkina Faso`,
  $localize`Burundi`,
  $localize`Cambodia`,
  $localize`Cameroon`,
  $localize`Canada`,
  $localize`Cape Verde`,
  $localize`Cayman Islands`,
  $localize`Central African Republic`,
  $localize`Chad`,
  $localize`Chile`,
  $localize`China`,
  $localize`Christmas Island`,
  $localize`Cocos (Keeling) Islands`,
  $localize`Colombia`,
  $localize`Comoros`,
  $localize`Congo`,
  $localize`Congo, The Democratic Republic of the`,
  $localize`Cook Islands`,
  $localize`Costa Rica`,
  $localize`Cote D'Ivoire`,
  $localize`Croatia`,
  $localize`Cuba`,
  $localize`Cyprus`,
  $localize`Czech Republic`,
  $localize`Denmark`,
  $localize`Djibouti`,
  $localize`Dominica`,
  $localize`Dominican Republic`,
  $localize`Ecuador`,
  $localize`Egypt`,
  $localize`El Salvador`,
  $localize`Equatorial Guinea`,
  $localize`Eritrea`,
  $localize`Estonia`,
  $localize`Ethiopia`,
  $localize`Falkland Islands (Malvinas)`,
  $localize`Faroe Islands`,
  $localize`Fiji`,
  $localize`Finland`,
  $localize`France`,
  $localize`French Guiana`,
  $localize`French Polynesia`,
  $localize`French Southern Territories`,
  $localize`Gabon`,
  $localize`Gambia`,
  $localize`Georgia`,
  $localize`Germany`,
  $localize`Ghana`,
  $localize`Gibraltar`,
  $localize`Greece`,
  $localize`Greenland`,
  $localize`Grenada`,
  $localize`Guadeloupe`,
  $localize`Guam`,
  $localize`Guatemala`,
  $localize`Guernsey`,
  $localize`Guinea`,
  $localize`Guinea-Bissau`,
  $localize`Guyana`,
  $localize`Haiti`,
  $localize`Heard Island and Mcdonald Islands`,
  $localize`Holy See (Vatican City State)`,
  $localize`Honduras`,
  $localize`Hong Kong`,
  $localize`Hungary`,
  $localize`Iceland`,
  $localize`India`,
  $localize`Indonesia`,
  $localize`Iran, Islamic Republic Of`,
  $localize`Iraq`,
  $localize`Ireland`,
  $localize`Isle of Man`,
  $localize`Israel`,
  $localize`Italy`,
  $localize`Jamaica`,
  $localize`Japan`,
  $localize`Jersey`,
  $localize`Jordan`,
  $localize`Kazakhstan`,
  $localize`Kenya`,
  $localize`Kiribati`,
  $localize`Korea, Democratic People'S Republic of`,
  $localize`Korea, Republic of`,
  $localize`Kuwait`,
  $localize`Kyrgyzstan`,
  $localize`Lao People'S Democratic Republic`,
  $localize`Latvia`,
  $localize`Lebanon`,
  $localize`Lesotho`,
  $localize`Liberia`,
  $localize`Libyan Arab Jamahiriya`,
  $localize`Liechtenstein`,
  $localize`Lithuania`,
  $localize`Luxembourg`,
  $localize`Macao`,
  $localize`Macedonia, The Former Yugoslav Republic of`,
  $localize`Madagascar`,
  $localize`Malawi`,
  $localize`Malaysia`,
  $localize`Maldives`,
  $localize`Mali`,
  $localize`Malta`,
  $localize`Marshall Islands`,
  $localize`Martinique`,
  $localize`Mauritania`,
  $localize`Mauritius`,
  $localize`Mayotte`,
  $localize`Mexico`,
  $localize`Micronesia, Federated States of`,
  $localize`Moldova, Republic of`,
  $localize`Monaco`,
  $localize`Mongolia`,
  $localize`Montserrat`,
  $localize`Morocco`,
  $localize`Mozambique`,
  $localize`Myanmar`,
  $localize`Namibia`,
  $localize`Nauru`,
  $localize`Nepal`,
  $localize`Netherlands`,
  $localize`Netherlands Antilles`,
  $localize`New Caledonia`,
  $localize`New Zealand`,
  $localize`Nicaragua`,
  $localize`Niger`,
  $localize`Nigeria`,
  $localize`Niue`,
  $localize`Norfolk Island`,
  $localize`Northern Mariana Islands`,
  $localize`Norway`,
  $localize`Oman`,
  $localize`Pakistan`,
  $localize`Palau`,
  $localize`Palestinian Territory, Occupied`,
  $localize`Panama`,
  $localize`Papua New Guinea`,
  $localize`Paraguay`,
  $localize`Peru`,
  $localize`Philippines`,
  $localize`Pitcairn`,
  $localize`Poland`,
  $localize`Portugal`,
  $localize`Puerto Rico`,
  $localize`Qatar`,
  $localize`Reunion`,
  $localize`Romania`,
  $localize`Russian Federation`,
  $localize`RWANDA`,
  $localize`Saint Helena`,
  $localize`Saint Kitts and Nevis`,
  $localize`Saint Lucia`,
  $localize`Saint Pierre and Miquelon`,
  $localize`Saint Vincent and the Grenadines`,
  $localize`Samoa`,
  $localize`San Marino`,
  $localize`Sao Tome and Principe`,
  $localize`Saudi Arabia`,
  $localize`Senegal`,
  $localize`Serbia and Montenegro`,
  $localize`Seychelles`,
  $localize`Sierra Leone`,
  $localize`Singapore`,
  $localize`Slovakia`,
  $localize`Slovenia`,
  $localize`Solomon Islands`,
  $localize`Somalia`,
  $localize`South Africa`,
  $localize`South Georgia and the South Sandwich Islands`,
  $localize`Spain`,
  $localize`Sri Lanka`,
  $localize`Sudan`,
  $localize`Suriname`,
  $localize`Svalbard and Jan Mayen`,
  $localize`Swaziland`,
  $localize`Sweden`,
  $localize`Switzerland`,
  $localize`Syrian Arab Republic`,
  $localize`Taiwan, Province of China`,
  $localize`Tajikistan`,
  $localize`Tanzania, United Republic of`,
  $localize`Thailand`,
  $localize`Timor-Leste`,
  $localize`Togo`,
  $localize`Tokelau`,
  $localize`Tonga`,
  $localize`Trinidad and Tobago`,
  $localize`Tunisia`,
  $localize`Turkey`,
  $localize`Turkmenistan`,
  $localize`Turks and Caicos Islands`,
  $localize`Tuvalu`,
  $localize`Uganda`,
  $localize`Ukraine`,
  $localize`United Arab Emirates`,
  $localize`United Kingdom`,
  $localize`United States`,
  $localize`United States Minor Outlying Islands`,
  $localize`Uruguay`,
  $localize`Uzbekistan`,
  $localize`Vanuatu`,
  $localize`Venezuela`,
  $localize`Viet Nam`,
  $localize`Virgin Islands, British`,
  $localize`Virgin Islands, U.S.`,
  $localize`Wallis and Futuna`,
  $localize`Western Sahara`,
  $localize`Yemen`,
  $localize`Zambia`,
  $localize`Zimbabwe`,
];

export const COUNTRY_NAMES_LATAM = [
  $localize`Argentina`,
  $localize`Belize`,
  $localize`Bolivia`,
  $localize`Brazil`,
  $localize`Chile`,
  $localize`Colombia`,
  $localize`Costa Rica`,
  $localize`Dominican Republic`,
  $localize`Ecuador`,
  $localize`El Salvador`,
  $localize`Guatemala`,
  $localize`Honduras`,
  $localize`Mexico`,
  $localize`Nicaragua`,
  $localize`Panama`,
  $localize`Paraguay`,
  $localize`Peru`,
  $localize`Puerto Rico`,
  $localize`Uruguay`,
  $localize`Venezuela`,
];

export const COUNTRY_NAMES = new InjectionToken<string[]>(
  'List of country names'
);
